import { SegmentOption } from 'src/app/components/gpd-segmented-switch/gpd-segmented-switch.component';

/** Whether cost amounts are shown gross (as stored) or net (derived from the VAT rate). */
export const AMOUNT_BASIS_OPTIONS: SegmentOption[] = [
  { label: $localize`:@@gross:Gross`, value: 0 },
  { label: $localize`:@@nett:Nett`, value: 1 },
];

/** 0 = Brutto, so the request field stays false and the API answers as it always did. */
export function amountBasisIsNetto(basis: number): boolean {
  return basis === 1;
}

/** Filename suffix. Deliberately not derived from the translated label. */
export function amountBasisFileSlug(basis: number): string {
  return basis === 1 ? 'netto' : 'brutto';
}
